import { ArrowRight, Check, MessagesSquare } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { getEnv } from '@/lib/env'

/**
 * Sección estática de la COMUNIDAD de soporte (goal
 * portal-comunidad-y-tickets-organizacion, decisiones 1 y 2): solo
 * invitación/CTA hacia comunidad.tecopos.com, sin feed vivo y sin CMS
 * (precedente TecoposCard/Hardware). El CTA vive tras `VITE_COMUNIDAD_URL`:
 * SIN la env la sección entera se oculta (la comunidad aún no está en
 * producción) — nada roto ni enlaces muertos. Textos por i18n (es/en).
 */
export function Comunidad() {
  const { t } = useTranslation()
  const comunidadUrl = getEnv('VITE_COMUNIDAD_URL')
  if (!comunidadUrl) return null

  const bullets = [
    t('community.bullet1'),
    t('community.bullet2'),
    t('community.bullet3'),
  ]

  return (
    <section id="comunidad" className="relative py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(45%_35%_at_50%_20%,rgba(0,98,255,0.08),transparent_70%)]" />
      <div className="max-w-7xl mx-auto px-5 lg:px-6 grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
        <div className="space-y-8 reveal">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">
            {t('community.badge')}
          </span>
          <h2 className="text-4xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
            {t('community.title')}
          </h2>
          <p className="text-muted-foreground text-lg max-w-lg">
            {t('community.description')}
          </p>

          <ul className="space-y-3 pt-2">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <span className="mt-1 size-5 rounded-full bg-primary/15 text-primary grid place-items-center">
                  <Check className="size-3" />
                </span>
                <span>{b}</span>
              </li>
            ))}
          </ul>

          <a
            href={comunidadUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 px-7 py-4 bg-primary text-primary-foreground font-bold rounded-xl hover:bg-primary/90 transition-all"
          >
            {t('community.cta')}
            <ArrowRight className="size-4 group-hover:translate-x-0.5 transition-transform" />
          </a>
        </div>

        <div className="relative hidden lg:block" aria-hidden="true">
          <div className="relative max-w-md mx-auto space-y-4">
            <div className="bg-white rounded-2xl border border-black/5 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.15)] p-6 rotate-[-1.5deg]">
              <div className="flex items-center gap-3 mb-3">
                <span className="size-9 rounded-full bg-primary/10 text-primary grid place-items-center">
                  <MessagesSquare className="size-4" />
                </span>
                <div>
                  <p className="text-sm font-semibold">
                    ¿Cómo cierro la caja del día en el POS?
                  </p>
                  <p className="text-[11px] text-muted-foreground">
                    Punto de venta · hace 2 horas
                  </p>
                </div>
              </div>
              <p className="text-sm text-muted-foreground line-clamp-2">
                Desde ayer no encuentro el botón de cierre después de la
                actualización…
              </p>
            </div>
            <div className="bg-white rounded-2xl border border-black/5 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.15)] p-6 ml-10 rotate-[1deg]">
              <div className="flex items-center justify-between mb-2">
                <p className="text-sm font-semibold">Solución aceptada ✓</p>
                <span className="text-[10px] uppercase tracking-widest text-emerald-600 font-bold">
                  Resuelto
                </span>
              </div>
              <p className="text-sm text-muted-foreground line-clamp-3">
                Ve a Turno → Cerrar caja. Si no aparece, revisa que tu usuario
                tenga el permiso de arqueo…
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
